import * as angular from 'angular';
import * as _ from 'lodash';
import {SchedulingProjectTemplateModel} from '../models/scheduling-project-template.model';

export interface SchedulingProjectTemplateUserScope {
  branchIds?: string[];
  groupIds?: string[];
  groupBranchIdsMap?: Record<string, string[]>;
}

export class SchedulingProjectTemplateFilterService {

  isGlobalTemplate(template: SchedulingProjectTemplateModel): boolean {
    return template?.global !== false;
  }

  isTemplateVisibleToUser(
    template: SchedulingProjectTemplateModel,
    userScope: SchedulingProjectTemplateUserScope
  ): boolean {
    if (this.isGlobalTemplate(template)) {
      return true;
    }

    const userBranchIds = userScope.branchIds || [];
    const userGroupIds = userScope.groupIds || [];
    const templateBranchIds = template.branchIds || [];
    const templateGroupIds = template.groupIds || [];

    if (!userBranchIds.length && !userGroupIds.length) {
      return true;
    }

    if (userBranchIds.length && templateBranchIds.some(id => userBranchIds.includes(id))) {
      return true;
    }

    if (userGroupIds.length && templateGroupIds.some(id => userGroupIds.includes(id))) {
      return true;
    }

    if (userBranchIds.length && templateGroupIds.length && userScope.groupBranchIdsMap) {
      return templateGroupIds.some(groupId => {
        const groupBranchIds = userScope.groupBranchIdsMap[groupId] || [];
        return groupBranchIds.some(branchId => userBranchIds.includes(branchId));
      });
    }

    return false;
  }

  filterTemplatesForUser(
    templates: SchedulingProjectTemplateModel[],
    userScope: SchedulingProjectTemplateUserScope
  ): SchedulingProjectTemplateModel[] {
    return (templates || []).filter(template => this.isTemplateVisibleToUser(template, userScope));
  }

  collectTemplateGroupIds(templates: SchedulingProjectTemplateModel[]): string[] {
    return _.uniq(_.flatMap(templates, template => {
      if (this.isGlobalTemplate(template)) {
        return [];
      }
      return template.groupIds || [];
    }));
  }

  buildGroupBranchIdsMap(groups: { id: string; branchIds?: string[] }[]): Record<string, string[]> {
    return _.reduce(groups, (map, group) => {
      map[group.id] = group.branchIds || [];
      return map;
    }, {} as Record<string, string[]>);
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .service('schedulingProjectTemplateFilterService', SchedulingProjectTemplateFilterService);
